import axios from '@/jslib/axios'

export const getPVRenewPromoList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/pv/renew/list',
    params,
    ...other
  })
}
export const getPVRenewPromoDetail= params => {
  return axios({
    method: 'get',
    url: '/admin/pv/renew/detail',
    params
  })
}
export const addPVRenewPromoRemark= data => {
  return axios({
    method: 'post',
    url: '/admin/pv/renew/add/remark',
    data
  })
}
export const updatePVRenewPromo= data => {
  return axios({
    method: 'post',
    url: '/admin/pv/renew/status/update',
    data
  })
}
export const editPVRenewPromo= data => {
  return axios({
    method: 'post',
    url: '/admin/pv/renew/edit',
    data
  })
}
